import { Box, TextField, Typography } from '@mui/material';
import React, { ChangeEvent, KeyboardEvent, RefObject } from 'react';

/**
 * @deprecated Use `PincodeAutoComplete` from `components/PincodeAutoComplete` instead.
 */
interface PincodeProps {
  name?: string;
  size?: 'small' | 'medium';
  error?: boolean;
  placeholder?: string;
  disable?: boolean;
  required?: boolean;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  maxLength?: number;
  inputRef?: RefObject<HTMLInputElement>;
  errormsg?: string;
}

/** @deprecated Use `PincodeAutoComplete` from `components/PincodeAutoComplete` instead. */
const Pincode = ({
  name,
  size,
  error,
  placeholder,
  disable,
  required,
  value,
  onChange,
  onBlur,
  onKeyDown,
  maxLength,
  inputRef,
  errormsg,
}: PincodeProps) => {
  // Generate a unique ID that doesn't match common address field names
  const uniqueId = name
    ? `pincode-${name.replace(/[^a-zA-Z0-9]/g, '-')}-${Math.random().toString(36).substr(2, 9)}`
    : `pincode-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <Box>
      {/* Hidden dummy input to trick browser autofill */}
      <input
        type="text"
        name={`dummy-${uniqueId}`}
        autoComplete="off"
        style={{ position: 'absolute', left: '-9999px', opacity: 0, pointerEvents: 'none', height: 0, width: 0 }}
        tabIndex={-1}
        readOnly
      />
      <TextField
        error={errormsg ? error : false}
        name={name}
        label={placeholder}
        variant="outlined"
        disabled={disable}
        size={size}
        fullWidth
        required={required}
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        autoComplete="new-password"
        inputProps={{
          maxLength: maxLength,
          autoComplete: 'new-password',
          autoCapitalize: 'off',
          autoCorrect: 'off',
          spellCheck: 'false',
          'data-form-type': 'other',
          'data-lpignore': 'true',
        }}
        InputProps={{
          autoComplete: 'new-password',
        }}
        sx={
          required === true
            ? {
                '.MuiFormLabel-asterisk': {
                  color: 'danger.main',
                  fontSize: '20px',
                  fontWeight: 'bold',
                },
              }
            : undefined
        }
        inputRef={inputRef}
      />
      <Typography
        sx={{
          marginTop: '2px',
          marginLeft: '10px',
          marginBottom: '0px',
          fontSize: '11px',
          color: 'danger.main',
        }}
      >
        {errormsg ? errormsg : ''}
      </Typography>
    </Box>
  );
};

export default Pincode;
